var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"border-2 border-accent absolute rounded-full top-0 left-0 spinner",class:_vm.sizeClasses}),_c('div',{staticClass:"border-2 rounded-full",class:_vm.sizeClasses})])}
var staticRenderFns = []

export { render, staticRenderFns }